module.exports = __webpack_public_path__ + "images/kihnu/routes/TAL-AEG-TAL.png";